import React from 'react';

function Belarus(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124172)">
        <mask
          id="mask0_800_124172"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124172)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#73BE4A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V16H36V0H0Z"
            fill="#AF0100"
          />
          <rect width="6.75" height="24" fill="#F7FCFF" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.499512 2.23605L2.13371 0.0568237L3.72585 2.23599L2.13367 4.31536L0.499512 2.23605ZM2.12768 3.42533L3.04362 2.22912L2.12763 0.975403L1.18752 2.22906L2.12768 3.42533ZM2.24976 2.06451H1.96851V2.58064H2.24976V2.06451Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.27896 4.18585L0.499512 5.17654L1.27894 6.1218L2.03835 5.17651L1.27896 4.18585ZM1.64352 5.19334L1.29231 5.61712L0.93689 5.16806L1.29137 4.703L1.64352 5.19334Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.96646 4.18585L2.18701 5.17654L2.96644 6.1218L3.72585 5.17651L2.96646 4.18585ZM3.33102 5.19334L2.97981 5.61712L2.62439 5.16806L2.97887 4.703L3.33102 5.19334Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.09146 4.18585L3.31201 5.17654L4.09144 6.1218L4.85085 5.17651L4.09146 4.18585ZM4.45602 5.19334L4.10481 5.61712L3.74939 5.16806L4.10387 4.703L4.45602 5.19334Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.77896 4.18585L4.99951 5.17654L5.77894 6.1218L6.53835 5.17651L5.77896 4.18585ZM6.14352 5.19334L5.79231 5.61712L5.43689 5.16806L5.79137 4.703L6.14352 5.19334Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.31201 2.23605L4.94621 0.0568237L6.53835 2.23599L4.94617 4.31536L3.31201 2.23605ZM4.94018 3.42533L5.85612 2.22912L4.94013 0.975403L4.00002 2.22906L4.94018 3.42533ZM5.06226 2.06451H4.78101V2.58064H5.06226V2.06451Z"
            fill="#B20000"
          />
          <path
            d="M1.86306 12.4061L0.0415039 9.68705L0.520709 9.41676L1.84122 11.3879L3.45246 8.75592L5.10374 11.3942L6.27047 9.67285L6.74813 9.94543L5.08452 12.3998L3.45788 9.80095L1.86306 12.4061Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 0.516113H1.14617V1.03224H0.84375V0.516113Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.375 0H3.67742V0.516129H3.375V0Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.90625 0.516113H6.20867V1.03224H5.90625V0.516113Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 3.61292H1.125V4.12904H0.84375V3.61292ZM3.375 3.61292H3.65625V4.12904H3.375V3.61292ZM6.1875 3.61292H5.90625V4.12904H6.1875V3.61292Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 6.19354H1.125V6.70967H0.84375V6.19354ZM3.375 6.19354H3.65625V6.70967H3.375V6.19354ZM6.1875 6.19354H5.90625V6.70967H6.1875V6.19354Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.48395 8.95476L1.73673 9.92298L0.558105 8.03608L2.11034 5.88025L3.44526 7.75949L4.78018 5.88025L6.33241 8.03608L5.15379 9.92298L4.40657 8.95476L4.99651 7.86449L4.78018 7.4215L3.51984 9.2387V9.45376L3.44526 9.34623L3.37068 9.45376V9.2387L2.11034 7.4215L1.894 7.86449L2.48395 8.95476Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.375 10.5806H3.65625V11.0968H3.375V10.5806ZM3.375 13.1613H3.65625V13.6774H3.375V13.1613ZM3.375 11.3548H3.09375V11.8709H3.375V11.3548ZM3.65625 11.3548H3.9375V11.8709H3.65625V11.3548ZM3.65625 11.871H3.375V12.129H3.09375V12.6452H3.375V12.3871H3.65625V12.6452H3.9375V12.129H3.65625V11.871ZM2.53125 11.871H2.8125V12.3871H2.53125V11.871ZM4.5 11.871H4.21875V12.3871H4.5V11.871ZM0.5625 11.8709H0.84375V12.3871H0.5625V11.8709ZM6.46875 11.871H6.1875V12.3871H6.46875V11.871Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.499512 21.7639L2.13371 23.9432L3.72585 21.764L2.13367 19.6846L0.499512 21.7639ZM2.12768 20.5747L3.04362 21.7709L2.12763 23.0246L1.18752 21.7709L2.12768 20.5747ZM2.24976 21.9355H1.96851V21.4194H2.24976V21.9355Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.27896 19.8141L0.499512 18.8235L1.27894 17.8782L2.03835 18.8235L1.27896 19.8141ZM1.64352 18.8067L1.29231 18.3829L0.93689 18.8319L1.29137 19.297L1.64352 18.8067Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.96646 19.8141L2.18701 18.8235L2.96644 17.8782L3.72585 18.8235L2.96646 19.8141ZM3.33102 18.8067L2.97981 18.3829L2.62439 18.8319L2.97887 19.297L3.33102 18.8067Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.09146 19.8141L3.31201 18.8235L4.09144 17.8782L4.85085 18.8235L4.09146 19.8141ZM4.45602 18.8067L4.10481 18.3829L3.74939 18.8319L4.10387 19.297L4.45602 18.8067Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.77896 19.8141L4.99951 18.8235L5.77894 17.8782L6.53835 18.8235L5.77896 19.8141ZM6.14352 18.8067L5.79231 18.3829L5.43689 18.8319L5.79137 19.297L6.14352 18.8067Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.31201 21.7639L4.94621 23.9432L6.53835 21.764L4.94617 19.6846L3.31201 21.7639ZM4.94018 20.5747L5.85612 21.7709L4.94013 23.0246L4.00002 21.7709L4.94018 20.5747ZM5.06226 21.9355H4.78101V21.4194H5.06226V21.9355Z"
            fill="#B20000"
          />
          <path
            d="M1.86306 11.5939L0.0415039 14.313L0.520709 14.5832L1.84122 12.6121L3.45246 15.2441L5.10374 12.6058L6.27047 14.3271L6.74813 14.0546L5.08452 11.6002L3.45788 14.1991L1.86306 11.5939Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 23.4839H1.14617V22.9678H0.84375V23.4839Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.375 24H3.67742V23.4839H3.375V24Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.90625 23.4839H6.20867V22.9678H5.90625V23.4839Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 20.3871H1.125V19.871H0.84375V20.3871ZM3.375 20.3871H3.65625V19.871H3.375V20.3871ZM6.1875 20.3871H5.90625V19.871H6.1875V20.3871Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.84375 17.8065H1.125V17.2903H0.84375V17.8065ZM3.375 17.8065H3.65625V17.2903H3.375V17.8065ZM6.1875 17.8065H5.90625V17.2903H6.1875V17.8065Z"
            fill="#B20000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.48395 15.1928L1.73673 14.2246L0.558105 16.1115L2.11034 18.2673L3.44526 16.3881L4.78018 18.2673L6.33241 16.1115L5.15379 14.2246L4.40657 15.1928L4.99651 16.2831L4.78018 16.7261L3.51984 14.9089V14.6938L3.44526 14.8014L3.37068 14.6938V14.9089L2.11034 16.7261L1.894 16.2831L2.48395 15.1928Z"
            fill="#B20000"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124172">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Belarus;
